export const bg = {
    'nav.today': "Преглед Днес",
    'nav.calendar': "Календар Търсене",
    'nav.rates': "Цени и Правила",
    'nav.automation': "Автоматизация",
    'nav.audit': "Одит Дневник",
    'nav.settings': "Настройки",
    'sidebar.status': "Свързано",
    'stat.occupancy': "Заетост",
    'stat.adr': "Ср. Цена (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Оч. Приход",
    'stat.trend.vsLastWeek': "спрямо Мин. Седмица",
    'stat.trend.onPace': "В график",
    'dashboard.actions.title': "Препоръчани Действия",
    'dashboard.actions.empty': "Няма намерени действия.",
    'filter.all': "Всички",
    'filter.pricing': "Цени",
    'filter.restriction': "Ограничения",
    'action.approve': "Одобри",
    'action.reject': "Отхвърли",
    'action.risk.low': "нисък риск",
    'action.risk.medium': "среден риск",
    'action.risk.high': "висок риск",
    'action.label.current': "Текущо",
    'action.label.proposed': "Предложено",
    'action.metric.impact': "Влияние",
    'action.metric.why': "Причина",
    'action.status.executed': "Авто-Изпълнено",
    'header.search': "Търсене...",
    'header.logout': "Изход",
    'auto.level.title': "Ниво Автопилот",
    'auto.level.manual': "Ръчно",
    'auto.level.manual.desc': "Одобрявате всяка препоръка.",
    'auto.level.assisted': "Асистирано",
    'auto.level.assisted.desc': "Авто-одобрение нисък риск. Преглед на големи промени.",
    'auto.level.auto': "Напълно Автом.",
    'auto.level.auto.desc': "AI управлява цените 24/7 във вашите граници.",
    'auto.level.active': "Активен",
    'auto.guardrails.title': "Предпазни Ленти",
    'auto.guardrails.maxIncrease': "Макс. Дн. Увеличение",
    'auto.guardrails.maxIncrease.desc': "Избягване на ценови шокове.",
    'auto.guardrails.maxDecrease': "Макс. Дн. Намаление",
    'auto.guardrails.maxDecrease.desc': "Избягване на дъмпинг.",
    'auto.guardrails.minRate': "Мин. Цена",
    'auto.guardrails.minRate.desc': "Никога не продавай под тази цена (Нето).",
    'auto.emergency.title': "Аварийно Управление",
    'auto.emergency.label': "Авариен Стоп",
    'auto.emergency.desc': "Незабавна пауза на автоматизацията.",
    'auto.emergency.btn': "ПАУЗА СИСТЕМА",
    'rates.filter.all': "Всички Типове Стаи",
    'rates.filter.next14': "Следващите 14 Дни",
    'rates.export': "Експорт",
    'audit.table.time': "Час",
    'audit.table.actor': "Потребител",
    'audit.table.category': "Категория",
    'audit.table.action': "Действие",
    'audit.table.details': "Детайли",
    'audit.table.status': "Статус",
    'settings.pms.title': "PMS Връзка",
    'settings.pms.connected': "Свързано с",
    'settings.pms.disconnect': "Разкачи",
    'settings.account.title': "Акаунт",
    'settings.account.role': "Роля",
    'settings.restart': "Рестарт Onboarding",
    'onboard.title': "Свържи PMS",
    'onboard.desc': "Изберете вашата система за управление (PMS).",
    'onboard.connecting': "Свързване...",
    'onboard.connect': "Свържи",
    'onboard.success.title': "Настройката Завършена!",
    'onboard.success.desc': "**SynthHotel Berlin** е синхронизиран.",
    'onboard.success.sub': "Импортирани 3 типа стаи, 14 ценови плана и 243 резервации.",
    'onboard.btn.dashboard': "Към Таблото",
    'action.dynamic.weekend.title': "Увеличи Цена Уикенд",
    'action.dynamic.weekend.desc': "Заетост > 75% Събота, силно търсене (+12 стаи за 24ч).",
    'action.dynamic.minstay.title': "Активирай Мин. Престой 2 Нощувки",
    'action.dynamic.minstay.desc': "Концерт Тейлър Суифт. Спри 1-дневни престои.",
    'action.dynamic.distress.title': "Намали Цена (Слабо Търсене)",
    'action.dynamic.distress.desc': "Заетост 35% следващия Вторник. Конкуренти свалиха €10.",
    'action.dynamic.gap.title': "Пълнене Дупка: Махни CTA",
    'action.dynamic.gap.desc': "Единична нощувка дупка. Махни 'Затворено за Пристигане'.",
};
